module.exports = __webpack_public_path__ + "99beef2b70f43ea264c2ee9ee53f8ba8.svg";